module.exports = __webpack_public_path__ + "static/media/undraw_design_tools_42tf.336b7cf9.svg";